import { Directive, ElementRef, AfterViewInit, Renderer2, OnDestroy } from '@angular/core';

@Directive({
    selector: '[ellipsifyContent]',
    standalone: false,
})
export class EllipsifyContentDirective implements AfterViewInit, OnDestroy {
    private element: HTMLElement;
    private elementChildren: HTMLElement[];
    private resizeObserver: ResizeObserver;
    private titleContent = '';

    constructor(private renderer: Renderer2, private elementRef: ElementRef) {
        this.element = this.elementRef.nativeElement as HTMLElement;
    }

    ngAfterViewInit(): void {
        this.renderer.setProperty(this.element, 'scrollTop', 1);
        this.addEllipsisStyles();

        this.resizeObserver = new ResizeObserver(() => {
            this.setContentAlignment();
            this.setTitleAttribute();
        });

        this.resizeObserver.observe(this.element);
    }

    private addEllipsisStyles(): void {
        const styles = {
            overflow: 'hidden',
            'text-overflow': 'ellipsis',
            'white-space': 'nowrap',
        };

        this.elementChildren = Array.from(this.element.children).map(
            (element) => element as HTMLElement
        );
        this.elementChildren
            .filter((elem) => !elem.className.includes('mat-icon'))
            .forEach((child) => {
                let content = child.textContent.trim();
                content += content[content.split('').length - 1] === '.' ? '' : '.';

                this.titleContent += `${content} `;

                Object.keys(styles).forEach((newStyle) => {
                    this.renderer.setStyle(child, `${newStyle}`, styles[newStyle]);
                });
            });
    }

    private setContentAlignment(): void {
        const alignTop = this.element.offsetHeight > this.element.parentElement.offsetHeight;

        alignTop
            ? this.renderer.setStyle(this.element.parentElement, 'align-items', 'start')
            : this.renderer.removeStyle(this.element.parentElement, 'align-items');
    }

    private setTitleAttribute(): void {
        const showTitle =
            this.elementChildren.some((element) => element.offsetWidth < element.scrollWidth) ||
            this.element.offsetHeight > this.element.parentElement.offsetHeight;

        showTitle
            ? this.renderer.setAttribute(this.element, 'title', this.titleContent)
            : this.renderer.removeAttribute(this.element, 'title');
    }

    ngOnDestroy(): void {
        this.resizeObserver.unobserve(this.element);
    }
}
